import axios from "axios";
import { isImpersonating, getImpersonationData } from "../utils/impersonation";

const API = axios.create({
  baseURL: import.meta.env.VITE_REACT_APP_BACKEND_BASEURL,
});

// Helpers para incluir token
const getAuthToken = () =>
  localStorage.getItem("token") ||
  localStorage.getItem("authToken") ||
  localStorage.getItem("scouterToken") ||
  localStorage.getItem("tokenAcesso") ||
  "";

const authHeaders = () => {
  const headers = {
    Authorization: `Bearer ${getAuthToken()}`,
  };
  if (isImpersonating()) {
    headers["x-admin-impersonation"] = "true";
    const imp = getImpersonationData();
    if (imp?.athleteId) {
      headers["x-impersonate-athlete-id"] = imp.athleteId;
    }
  }
  return { headers };
};

export const getGames = () => API.get("/games");
export const getGame = (id) => API.get(`/games/${id}`);
export const createGame = (data) => API.post("/games", data);
export const updateGame = (id, data) => API.put(`/games/${id}`, data);
export const deleteGame = (id) => API.delete(`/games/${id}`);

export const getTeams = () => API.get("/teams"); // para listar os times
export const getTeamAthletes = (teamId) => API.get(`/teams/${teamId}`); // assumir que retorna os atletas

// ===== Descontos Progressivos =====
export const getDiscountTiers = () => API.get(`/parametros/descontos`, authHeaders());
export const setDiscountTiers = (data) => {
  if (Array.isArray(data)) {
    return API.put(`/parametros/descontos`, { tiers: data, minPhotos: 1 }, authHeaders());
  }
  return API.put(`/parametros/descontos`, data, authHeaders());
};

// ===== Log de Acesso =====
export const logAccess = async (area, page) => {
  try {
    // Se o admin estiver navegando no modo de simulação, NUNCA registra log para não sensibilizar dados reais do atleta
    if (isImpersonating()) {
      return;
    }

    const token = getAuthToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const path = typeof window !== "undefined" && window.location ? window.location.pathname : page;
    // Capturar nome do usuário do localStorage quando disponível
    let userName;
    try {
      const userRaw =
        localStorage.getItem("user") ||
        localStorage.getItem("adminUser") ||
        localStorage.getItem("scouterUser") ||
        "";
      if (userRaw) {
        const userObj = JSON.parse(userRaw);
        userName = userObj?.nome || userObj?.name || undefined;
      }
    } catch {}

    await API.post(
      `/access-log`,
      { area, page, path, ...(userName ? { userName } : {}) },
      { headers }
    );
  } catch (e) {
    // Silencioso: não interromper a navegação por falha de log
  }
};

export const getAccessLogs = (params = {}) =>
  API.get(`/access-log`, { params, ...authHeaders() });

export default API;
